/* ============================================================
   Funday — Funday quick-buy modal
   Click "Quick add" → fetch product → pick size + qty → Buy now / Add to cart.
   Uses Shopify storefront endpoints: /products/{handle}.js and /cart/add.js
   ============================================================ */
(function () {
  'use strict';

  var modal = document.querySelector('[data-quickbuy]');
  if (!modal) return;

  var els = {
    track: modal.querySelector('[data-qb-track]'),
    dots: modal.querySelector('[data-qb-dots]'),
    prev: modal.querySelector('[data-qb-prev]'),
    next: modal.querySelector('[data-qb-next]'),
    title: modal.querySelector('[data-qb-title]'),
    price: modal.querySelector('[data-qb-price]'),
    options: modal.querySelector('[data-qb-options]'),
    qty: modal.querySelector('[data-qb-qty]'),
    inc: modal.querySelector('[data-qb-inc]'),
    dec: modal.querySelector('[data-qb-dec]'),
    note: modal.querySelector('[data-qb-note]'),
    buy: modal.querySelector('[data-qb-buy]'),
    add: modal.querySelector('[data-qb-add]'),
    err: modal.querySelector('[data-qb-err]')
  };

  var state = { product: null, variant: null, loading: false };

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function openModal() { modal.hidden = false; modal.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeModal() { modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  function setQty(v) {
    var n = parseInt(v, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 99) n = 99;
    els.qty.value = n;
    return n;
  }

  function selectVariant(variant) {
    state.variant = variant;
    els.price.textContent = money(variant.price);
    // toggle active button
    Array.prototype.forEach.call(els.options.querySelectorAll('button'), function (b) {
      b.classList.toggle('is-active', String(b.getAttribute('data-vid')) === String(variant.id));
    });
    var available = variant.available;
    els.buy.disabled = !available;
    els.add.disabled = !available;
    els.note.hidden = available;
    if (!available) { els.note.hidden = false; els.note.textContent = 'This size is sold out.'; }
  }

  function buildCarousel(p) {
    var imgs = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean);
    els.track.innerHTML = imgs.map(function (src) {
      return '<img src="' + src + '" alt="' + (p.title || '') + '" loading="lazy">';
    }).join('');
    els.dots.innerHTML = imgs.map(function (_, i) { return '<button type="button" data-d="' + i + '" aria-label="Image ' + (i + 1) + '"></button>'; }).join('');
    var n = imgs.length, idx = 0;
    function go(i) {
      idx = (i + n) % n;
      els.track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      Array.prototype.forEach.call(els.dots.children, function (d, di) { d.classList.toggle('is-active', di === idx); });
    }
    els.prev.hidden = els.next.hidden = n < 2;
    els.dots.style.display = n < 2 ? 'none' : '';
    els.prev.onclick = function () { go(idx - 1); };
    els.next.onclick = function () { go(idx + 1); };
    Array.prototype.forEach.call(els.dots.children, function (d) { d.onclick = function () { go(parseInt(d.getAttribute('data-d'), 10)); }; });
    var sx = null;
    els.track.ontouchstart = function (e) { sx = e.touches[0].clientX; };
    els.track.ontouchend = function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); sx = null; };
    go(0);
  }

  function renderProduct(p) {
    state.product = p;
    els.err.hidden = true;
    els.title.textContent = (p.title || '').replace(/Golf Head Cover|Head Cover/g, '').trim();
    buildCarousel(p);
    // size buttons from variants
    els.options.innerHTML = '';
    p.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-vid', v.id);
      b.textContent = v.title;
      if (!v.available) b.classList.add('is-soldout');
      b.addEventListener('click', function () { selectVariant(v); });
      els.options.appendChild(b);
    });
    // default to first available variant, else first
    var def = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    selectVariant(def);
    setQty(1);
  }

  function loadProduct(handle, trigger) {
    if (state.loading) return;
    state.loading = true;
    openModal();
    els.title.textContent = 'Loading…';
    els.options.innerHTML = '';
    els.price.textContent = '';
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('fetch'); return r.json(); })
      .then(function (p) { renderProduct(p); })
      .catch(function () { els.err.hidden = false; els.title.textContent = 'Could not load product'; })
      .finally(function () { state.loading = false; });
  }

  function addToCart(redirect) {
    if (!state.variant || state.variant.available === false) return;
    var btn = redirect === '/checkout' ? els.buy : els.add;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variant.id, quantity: setQty(els.qty.value) }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = redirect; })
      .catch(function () { els.err.hidden = false; btn.disabled = false; btn.textContent = label; });
  }

  // Wire triggers (event delegation so it works for any card)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quickadd]');
    if (t) { e.preventDefault(); loadProduct(t.getAttribute('data-handle'), t); }
  });

  modal.querySelectorAll('[data-quickbuy-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

  els.inc.addEventListener('click', function () { setQty(parseInt(els.qty.value, 10) + 1); });
  els.dec.addEventListener('click', function () { setQty(parseInt(els.qty.value, 10) - 1); });
  els.qty.addEventListener('change', function () { setQty(els.qty.value); });

  els.buy.addEventListener('click', function () { addToCart('/checkout'); });
  els.add.addEventListener('click', function () { addToCart('/cart'); });
})();
